<script lang="ts" setup>
import { computed } from 'vue';
import { Menu } from '~/types';
import ExternalLinkWarning from '../ui/ExternalLinkWarning.vue';

interface Props {
  item: Menu.MenuItem;
  level?: number;
}

const props = withDefaults(defineProps<Props>(), { level: 0 });

const levelCssClass = computed<string>(() => `menu-item--level-${props.level}`);
</script>

<template>
  <li class="menu-item" :class="levelCssClass">
    <a
      :href="item.value || '#'"
      :target="item.target || '_blank'"
      :role="!item.value ? 'button' : undefined"
      class="menu-item__link"
      :class="{ 'menu-item__link--title': item.children?.length > 0 }"
    >
      {{ item.name }}
      <ExternalLinkWarning :target="item.target" />
    </a>
    <ul v-if="item.children?.length > 0" class="menu-item__inner-list">
      <template v-for="(childrenMenuItem, index) in item.children">
        <component
          :is="childrenMenuItem.component"
          v-if="childrenMenuItem?.component"
          :key="childrenMenuItem.id"
          :item="childrenMenuItem"
          :index="index"
          :level="level + 1"
        />
      </template>
    </ul>
  </li>
</template>
